<template>
    <div class="no-chat-found-container">
        <div class="live-support-image">
            <img src="/static/img/liveSupportChat.svg" />
        </div>
        <div class="messages-content">
            <div class="message-system">
                <div class="title">Hiç aktif sohbet bulunamadı.</div>
                <div class="subtitle">Bu kısımda aktif sohbetler ve size atanan sohbetleri görebilirsiniz.</div>
            </div>
            <div class="customer-page-button" @click="openCustomerPanel">
                <img class="message-img" src="/static/img/message-smile-square-svgrepo-com.svg" />
                <span>{{ $t("message.customerPage") }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCog, faComment, faCommentAlt, faCommentDots, faEye } from "@fortawesome/free-solid-svg-icons";
import { log2 } from "../utils/log2";

library.add(faCommentDots, faCog, faEye, faComment, faCommentAlt);

const log = log2("NoCahatFound");
export default {
    name: "noChatFound",
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            visitorScreenUrl: (state) => {
                const isProduction = process.env.ENVIRONMENT === "production";
                const isStage = process.env.ENVIRONMENT === "stage";
                let siteAlias = (state.site.site.customerClientAddress || "").replace(".visitor.supsis.live", "");
                const protocol = isProduction || isStage ? "https" : "http";
                if (siteAlias === "visitor.supsis.live") siteAlias = "demo-site.supsis.live?customer=supsis";
                else siteAlias = "demo-site.supsis.live?customer=" + siteAlias;
                const hostname = isProduction
                    ? siteAlias
                    : isStage
                    ? `demo-site.supsis.live?url=${protocol}://${
                          state.site.site.customerClientAddress || "betavisitor.supsis.live"
                      }/static/js/loader.js`
                    : "localsite.supsis.live?customer=local";
                return `${protocol}://${hostname}`;
            },
            isMobile: (state) => state.app.isMobile,
        }),
    },
    methods: {
        openCustomerPanel() {
            window.open(this.visitorScreenUrl, "_blank");
        },
    },
};
</script>

<style lang="scss" scoped>
.no-chat-found-container {
    margin-top: -100px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;

    @media (max-width: 800px) {
        .live-support-image {
            display: none;
        }
        .message-system {
            width: 300px !important;
            height: 140px !important;
            border-radius: 5px !important;
        }
    }

    .live-support-image {
        width: 400px;
    }

    .messages-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 50px !important;

        .message-system {
            border: 1px solid var(--border-neutral-default);
            color: var(--color-text-default);
            border-radius: 10px 130px 130px 130px;
            width: 400px;
            height: 200px;
            overflow: hidden;
            padding: 40px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .title {
                font-size: 18px;
                font-weight: bold;
                text-transform: uppercase;
                margin-bottom: 10px;
            }

            .subtitle {
                font-size: 16px;
            }
        }

        .customer-page-button {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 4px;
            background: var(--bg-primary-default);
            border-radius: 100px;
            height: 40px;
            width: max-content;
            padding: 10px 40px;
            font-size: 16px;
            color: white;
            cursor: pointer;

            img {
                width: 20px;
            }
        }
    }
}
</style>
